/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_InactiveInputs */

const cs_gdpr_inactive = /** @type {(inputs: Gdpr_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neaktivní`)
};

const en_gdpr_inactive = /** @type {(inputs: Gdpr_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Gdpr_InactiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_inactive = /** @type {((inputs?: Gdpr_InactiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_InactiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_inactive(inputs)
	return cs_gdpr_inactive(inputs)
});